import LangEnum from '../../../lang/LangEnum';
import { ConditionError, OrderError } from '../edit/sections/OrderEditSections.types';
import {
  FIELDS_BY_ERROR_CODE,
  MORE_CONDITIONS_FIELDS,
  ORDER_WIDE_ERROR_CODES,
  OrderConditionFieldWithError,
} from './orderConditionFieldErrors.map';

export type { OrderConditionFieldWithError };

export const hasMoreConditionsError = (
  fieldsWithError: Set<OrderConditionFieldWithError>,
  errors: OrderError[],
) =>
  MORE_CONDITIONS_FIELDS.some((field) => fieldsWithError.has(field)) ||
  errors.some(({ messageCode }) => messageCode === LangEnum.ORDER_CONDITIONS_CUSTOM_FIELDS_RULE);

export const isOrderWideConditionError = ({ messageCode }: OrderError) =>
  ORDER_WIDE_ERROR_CODES.includes(messageCode);

export const getOrderConditionErrors = (
  conditionErrors: ConditionError[],
  orderConditionId?: string,
): OrderError[] =>
  conditionErrors.find((condition) => condition.orderConditionId === orderConditionId)?.errors ??
  [];

export const getOrderConditionFieldsWithError = (
  conditionErrors: ConditionError[],
  orderConditionId?: string,
): Set<OrderConditionFieldWithError> => {
  const errors =
    conditionErrors.find((condition) => condition.orderConditionId === orderConditionId)?.errors ??
    [];

  return new Set(errors.flatMap(({ messageCode }) => FIELDS_BY_ERROR_CODE[messageCode] ?? []));
};
